import * as Immutable from "immutable";
export default class Capability {
  constructor(id, title) {
    this._value = { id, title };
  }
  get id() {
    return this._value.id;
  }
  get title() {
    return this._value.title;
  }
  toBuilder() {
    const { id, title } = this._value;
    return new Builder(Immutable.Map({ id, title }));
  }
  toJSON() {
    const { id, title } = this._value;
    return { id, title };
  }
  static fromJSON(value) {
    const { id, title } = value;
    return Capability.builder().id(id).title(title).build();
  }
  static builder() {
    return new Builder();
  }
}
class Builder {
  constructor(value = Immutable.Map()) {
    this.value = value;
  }
  id(value) {
    return new Builder(this.value.set("id", value));
  }
  title(value) {
    return new Builder(this.value.set("title", value));
  }
  build() {
    const { id, title } = this.value.toObject();
    return new Capability(id, title);
  }
}
